<template>
  <Wrapper hasChildren :styleList="wrapperStyle" @openEditor="openEditor" @openChildEditor="openChildEditor">
    <div class="media-text-container" :style="containerStyle">
      <div class="title" :class="!title && 'no-wrapper'">
        <div class="title-text module-text-title" ref="titleEl">{{ title }}</div>
        <div class="under-line" :style="titleUnderLineStyle">
          <el-divider v-if="hasTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="sub-title" :class="!subTitle && 'no-wrapper'">
        <div class="sub-title-text module-text-content" ref="subTitleEl">{{ subTitle }}</div>
        <div class="under-line" :style="subTitleUnderLineStyle">
          <el-divider v-if="hasSubTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="content-container" ref="contentContainer" :class="[renderMode, hideItemMargin && 'hide-item-margin']">
        <slot></slot>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Wrapper from '../../../components/render/wrapper.vue'
import { RENDER_MODE, CHILD_EDITOR_NAME } from '../constant'
import RenderMixin from '../../renderMixin'

const componentName = 'MediaAndText'
export {
  componentName
}

export default {
  name: componentName,
  mixins: [RenderMixin],
  components: {
    Wrapper
  },
  props: {
    renderMode: {
      type: String,
      required: true,
      validator: (value) => {
        return _.find(RENDER_MODE, (itemValue) => itemValue === value)
      }
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    underLine: {
      type: Object,
      required: false
    },
    hideItemMargin: {
      type: Boolean,
      default: false
    },
    styleConfig: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      containerObserver: null
    }
  },
  computed: {
    ...mapGetters('microSite', ['isMobile']),
    wrapperStyle () {
      let width
      if (this.isEditMode) {
        width = this.isMobile ? this.width : null
      } else {
        width = this.width
      }
      return {
        width,
        marginTop: this.hideItemMargin && '0px',
        marginBottom: this.hideItemMargin && '0px'
      }
    },
    containerStyle () {
      let width
      if (this.isEditMode) {
        width = this.isMobile ? null : this.width
      } else {
        width = 'auto'
      }
      return {
        width
        // height: this.height
      }
    },
    hasTitleUnderLine () {
      return this.underLine && this.underLine.title && this.underLine.title.isShow && this.title && this.subTitle
    },
    hasSubTitleUnderLine () {
      return this.underLine && this.underLine.subTitle && this.underLine.subTitle.isShow
    },
    titleUnderLineStyle () {
      return this.formatUnderLineStyle('title', this.underLine.title)
    },
    subTitleUnderLineStyle () {
      return this.formatUnderLineStyle('subTitle', this.underLine.subTitle)
    }
  },
  created () {

  },
  mounted () {
    if (this.renderMode === RENDER_MODE.horizontalMultiple) {
      const contentContainer = this.$refs.contentContainer
      this.containerObserver = new MutationObserver(this.mutationObserverCallback)
      this.containerObserver.observe(contentContainer, {
        childList: true,
        subtree: true
      })
      this.mutationObserverCallback()
    }
  },
  beforeDestroy () {
    if (this.containerObserver) {
      this.containerObserver.disconnect()
    }
  },
  methods: {
    mutationObserverCallback (mutationsList, observer) {
      const contentContainer = this.$refs.contentContainer
      const children = contentContainer.children
      const childrenCount = contentContainer.childElementCount
      if (childrenCount < 1) {
        return
      }
      const lastRowItemCount = childrenCount % 4
      if (lastRowItemCount < 1) {
        for (let i = 0; i < 4; i++) {
          children[childrenCount - 1 - i].classList.remove('last-row', 'last-row-1', 'last-row-2', 'last-row-3')
        }
      } else {
        for (let i = 0; i < lastRowItemCount; i++) {
          const classList = children[childrenCount - 1 - i].classList
          classList.remove('last-row-1', 'last-row-2', 'last-row-3')
          classList.add('last-row', `last-row-${lastRowItemCount}`)
        }
      }
    },
    formatUnderLineStyle (type, config, isSelfTigger) {
      let width = config.width
      let el = null
      if (this.$refs) {
        if (type === 'title') {
          el = this.$refs.titleEl
        } else if (type === 'subTitle') {
          el = this.$refs.subTitleEl
        } else if (type === 'content') {
          el = this.$refs.contentEl
        }
      }
      if (el) {
        if (!width || width === 'full') {
          width = '100%'
        } else if (!isNaN(width)) {
          width = width + 'px'
        } else if (width === 'compute') {
          width = (el.clientWidth + 60) + 'px'
        }
        const underLineEl = el.nextElementSibling.firstElementChild
        if (underLineEl) {
          const style = underLineEl.style
          style.width = width
          style.backgroundColor = config.color || '#DCDFE6'
        }
      } else if (!isSelfTigger) {
        this.$nextTick(() => this.formatUnderLineStyle(type, config, true))
      }
      return { }
    },
    openEditor () {
      this.$emit('openEditor')
    },
    openChildEditor () {
      this.$emit('openChildEditor', {
        editorName: CHILD_EDITOR_NAME,
        fromChild: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .media-text-container {
    text-align: center;

    .under-line {
      width: 100%;

      .el-divider {
        margin: 0 auto;
      }
    }

    .title {
      margin-bottom: 20px;
    }

    .title-text, .sub-title-text {
      display: inline-block;
    }

    ::v-deep .content-container {
      position: relative;

      &.horizontal-multiple {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;

        .child-wrapper {
          display: inline-block;
          min-width: 140px;
          vertical-align: top;
        }
      }

      &.horizontal-single {
        &.hide-item-margin {
          margin-top: 0;
          .content-item {
            .media-container {
              margin-bottom: 0;
            }
          }
        }
        .content-item {
          .media-container {
            width: 100%;
            .image {
              width: 100%;
            }
          }
        }
      }

      &.vertical-single-right {
        .child-wrapper {
          .content-item {
            display: flex;
            justify-content: center;
            align-items: center;
            .media-container {
              order: 2;
            }

            .text-container {
              margin-right: 20px;
              order: 1;
              text-align: right;
            }
          }
        }
      }

      &.vertical-single-left {
        .child-wrapper {
          .content-item {
            display: flex;
            justify-content: center;
            align-items: center;

            .media-container {
              order: 1;
            }

            .text-container {
              margin-left: 20px;
              order: 2;
              text-align: left;
            }
          }
        }
      }

      &.vertical-crossed {
        .child-wrapper {
          margin-bottom: 20px;

          .content-item {
            display: flex;

            .media-container {
              flex: 1;
              order: 1;
            }

            .text-container {
              flex: 1;
              order: 2;
              margin-left: 20px;
              text-align: left;

              .content {
                .content-text {
                  text-align: left;
                }
              }
            }
          }

          &:nth-child(2n) {
            .content-item {
              .media-container {
                order: 2;
              }

              .text-container {
                order: 1;
                margin-left: 0;
                margin-right: 20px;
              }
            }
          }
        }
      }
    }
  }
}

.site-mobile {
  .media-text-container {
    .title {
      .under-line {
        margin-top: 10px;
      }
    }

    :not(.no-wrapper) ~ .content-container {
      margin-top: 20px;
    }

    ::v-deep .content-container {
      &.horizontal-multiple {
        margin-top: 0;
        justify-content: space-around;

        .child-wrapper {
          margin-top: 40px;
          width: 31%;
          min-width: unset;

          .content-item {
            .media-container {
              * {
                margin: auto;
              }
            }
          }
        }
      }

      &.horizontal-single {
        margin-top: 20px;

        .content-item {
          .media-container {
            margin-bottom: 20px;
          }
        }
      }

      &.vertical-single-right {

      }

      &.vertical-single-left {

      }

      &.vertical-crossed {
        .content-item {
          .media-container {
            display: flex;
            align-items: flex-start;

            * {
              margin: 20px auto 0;
            }
          }
        }
      }
    }
  }
}

.site-pc {
  .media-text-container {
    width: 1080px;
    margin: 0 auto;

    .title {
      .under-line {
        margin-top: 20px;
      }
    }

    :not(.no-wrapper) ~ .content-container {
      margin-top: 40px;
    }

    ::v-deep .content-container {

      &.horizontal-multiple {
        margin-top: 0;

        .child-wrapper {
          width: 240px;
          margin: 0;
          margin-top: 40px;
          margin-right: 20px;
          margin-left: 20px;

          .content-item {
            .media-container {
              .image {
                width: 100%;
              }
            }
          }
        }
      }

      &.horizontal-single {
        .content-item {
          .media-container {
            margin-bottom: 40px;
          }
        }
      }

      &.vertical-single-right {

      }

      &.vertical-single-left {

      }

      &.vertical-crossed {
        .child-wrapper {
          margin-bottom: 40px;

          &:last-child {
            margin-bottom: 0;
          }

          .content-item {
            .media-container {
              flex: 1;
              margin-left: 0;
              margin-right: 30px;

              .image {
                width: 100%;
              }
            }

            .text-container {
              flex: 1;
              margin-left: 30px;
              margin-right: 0;
            }
          }

          &:nth-child(2n) {
            .content-item {
              .media-container {
                margin-left: 30px;
                margin-right: 0;
              }

              .text-container {
                margin-left: 0;
                margin-right: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
